function toutou_xy_profils(myJson,fcstind,ctx=undefined){

  // Donnees de MySQL
  var ni       = myJson.hhh.length; 
  var nk       = myJson.levs.length; 

  var work     = new Array(ni*nk);
  var work2    = new Array(ni*nk);
  var stable   = new Array(nk);
  var tracer   = new Array(nk);
  var force    = new Array(nk);
  var dir      = new Array(nk);
  var temp     = new Array(nk);
  var ttdd     = new Array(nk);
  var p0       = new Array(ni);
  var hhh      = new Array(ni);
  var levs     = new Array(nk);
  var levels3  = [1050,1030,1015,1000,985,970,950,925,900,875,850,800,750,700,650];
  var ind      = 0;
  var thermo   = new Toutou_Thermo();
  var datev    = dateo;
  var my_fonts = new Toutou_Fonts(); 
  var tr       = new Toutou_Transform();
  var aaaammjj = myJson.aaaammjj; 
  var hh       = myJson.hh; 
  var deg2rad = Math.PI/180.
  var td_particule =0.;
  var tt_particule =0.;
  var k_particule =-1;

  unitJson=toutou_get_option('unite_vent');

  for (var i=0; i < ni*nk; i++) {
    work[i]=myJson.data2[i]*.01;
    // Note : Prendre le point de rosee comme valeur min est trop froid, on prend plutot la temperature
    //work2[i]=myJson.data2[i]*.01-myJson.data3[i]*.01;
    work2[i]=myJson.data2[i]*.01;
  }
  tr.xmax=work.max()+0.08*(work.max()-work2.min());
  tr.xmin=work2.min()-0.15*(work.max()-work2.min()); 
  tr.xmax=Math.min(tr.xmax,40.);
  tr.xmin=Math.max(tr.xmin,-60.);

  for (var i=0; i < ni; i++) {
    p0[i]=myJson.data4[i]*.1;
    hhh[i]=myJson.hhh[i]; 
  }
  // myJson.data1[i] = 1000*(force*10) + dir
  for (var k=0; k < nk; k++) {
    ind=nk*fcstind+k;
    force[k]= Math.floor(myJson.data1[ind]/1000.); 
    dir[k]= myJson.data1[ind] - force[k]*1000; 
    force[k]=force[k]/10.*unitJson.conv; 
    temp[k]=myJson.data2[ind]*.01;
    ttdd[k]=temp[k]-myJson.data3[ind]*.01;            
    levs[k]=myJson.levs[k];
  }

  // Obtenir le tr.ymin tr.ymax (pression), echelle inversee. 
  tr.ymin=1050; 
  tr.ymax=levs[nk-1];

  pointsData['profils'] = [];
  
  // Espace autour de la boite du graphique en %
  var pil_w=.12;
  var pil_e=.18;
  var pil_s=.15;
  var pil_n=.15;
 
  if(ctx == undefined) ctx=set_canvas('toutou_xy_profils');

  tr.pix_margeg=Math.round((   pil_w)*gxsize)+.5;
  tr.pix_marged=Math.round((1.-pil_e)*gxsize)+.5;
  tr.pix_margeh=Math.round((   pil_n)*gysize)+.5;
  tr.pix_margeb=Math.round((1.-pil_s)*gysize)+.5;      
  
  tr.init();

  pointsData['profils_params'] = { xmin_pix: tr.d2px(tr.xmin), xmax_pix: tr.d2px(tr.xmax),
				ymin_pix: tr.d2py(tr.ymin), ymax_pix: tr.d2py(tr.ymax),
			        tt_col: 'blue', td_col:'green'};
  
  tr.xmin_pix=tr.d2px(tr.xmin);
  tr.xmax_pix=tr.d2px(tr.xmax);
  tr.ymin_pix=tr.d2py(tr.ymin);
  tr.ymax_pix=tr.d2py(tr.ymax);      

  ctx.fillStyle = "#FFF";  
  ctx.fillRect(0, 0, gxsize,gysize);

  // Titre principal
  ctx.font = my_fonts.principal;
  ctx.fillStyle = "#33A"; 
  ctx.textAlign="center";
  ctx.textBaseline="top";
  var model_names = {'H': 'HRDPS', 'R': 'RDPS', 'G': 'GDPS'};
  var model_str = (myJson.modele && myJson.modele[fcstind]) ? ' du ' + (model_names[myJson.modele[fcstind]] || myJson.modele[fcstind]) : '';
  datev.setHours(datev.getHours()+hhh[fcstind]);
  ctx.fillText('Prévision de '+hhh[fcstind]+' h'+model_str+', valide le '+toutou_xy_titre_principal(datev),.5*(tr.xmax_pix+tr.xmin_pix),0);
  datev.setHours(datev.getHours()-hhh[fcstind]);
  ctx.restore(); 
  
  //
  ctx.font = my_fonts.legende;
  ctx.fillStyle = "black";  
  ctx.textAlign="center"; 
  ctx.textBaseline="bottom"; 
  ctx.fillText("Glissez votre doigt sur le graphique pour changer l'heure <--->",.5*(tr.xmax_pix+tr.xmin_pix),tr.ymax_pix+tr.dd);  
  ctx.restore();  
  
  // iMeteo.ca en filigran
  ctx.font = "140px Times New Roman";
  ctx.fillStyle = "#F0F0FF";
  ctx.textAlign="center";
  ctx.textBaseline="middle";
  ctx.fillText('iMeteo.ca',.5*(tr.xmax_pix+tr.xmin_pix),.5*(tr.ymax_pix+tr.ymin_pix));
  
  //===============================
  // Tracer les adiabatiques seches
  ctx.beginPath(); 
  ctx.strokeStyle = 'grey'; 
  for(i=-40;i<=60;i=i+5){
    theta=i+thermo.tcdk;
    for(j=0;j<levels3.length;j++){ 
      tempo=theta*Math.pow(levels3[j]/thermo.p0theta,thermo.cappa)-thermo.tcdk; 
      xx_pix=tr.d2px(tempo);
      yy_pix=tr.d2py(levels3[j]);
      if(j == 0){
	ctx.beginPath();
	ctx.moveTo(xx_pix,yy_pix);
      } else {
	ctx.lineTo(xx_pix,yy_pix);
      }
    }
    ctx.stroke();
  }

  //=======================================
  //Tracer les pseudo-adiabatiques saturees
  for(ii=-40;ii<=48;ii=ii+4){
    var res=thermo.pseudo_adiabatique_saturee(ii+thermo.tcdk,1000.,650.,-10.);
    ctx.beginPath();
    ctx.fillStyle = 'pink';
    ctx.strokeStyle = 'pink';
    ctx.beginPath();
    xx=tr.d2px(res.tt[0]-thermo.tcdk);
    yy=tr.d2py(res.pp[0]);	
    ctx.moveTo(xx,yy);
    for (var k=1; k < res.n; k++) {
      xx=tr.d2px(res.tt[k]-thermo.tcdk);
      yy=tr.d2py(res.pp[k]);	
      ctx.lineTo(xx,yy);
    }
    ctx.stroke();  
  }
  
  // Tracer la boite
  ctx.beginPath();
  ctx.strokeStyle = 'black';
  ctx.moveTo(tr.pix_margeg,tr.pix_margeh);
  ctx.lineTo(tr.pix_marged,tr.pix_margeh);
  ctx.lineTo(tr.pix_marged,tr.pix_margeb);
  ctx.lineTo(tr.pix_margeg,tr.pix_margeb);
  ctx.lineTo(tr.pix_margeg,tr.pix_margeh);
  ctx.stroke();
  
  // xticks
  ctx.beginPath();
  ctx.font = my_fonts.axis;
  ctx.fillStyle = "black";
  ctx.strokeStyle = 'black';
  ctx.textAlign="center";
  ctx.textBaseline="top";
  nx=(Math.floor(tr.xmax)-Math.ceil(tr.xmin)+1);
  inc=1;
  if(tr.xmax-tr.xmin > 30){inc=2;}
  if(tr.xmax-tr.xmin > 40){inc=5;}
  yy_pix=Math.round(tr.ymin_pix-.025*(tr.ymax_pix-tr.ymin_pix))+.5;
  for (var i=0; i < nx; i=i+inc) {
    val=Math.ceil(tr.xmin)+i;
    xx_pix=Math.round(tr.d2px(val))+.5;
    ctx.moveTo(xx_pix,tr.ymin_pix);
    ctx.lineTo(xx_pix,yy_pix);
    ctx.fillText(val,xx_pix,yy_pix);
  }
  ctx.stroke();

  // Legende x
  ctx.textAlign="center";
  ctx.textBaseline="top";
  ctx.font = my_fonts.axis;
  ctx.fillStyle = "black";
  ctx.fillText("Température [C]",.5*(tr.xmax_pix+tr.xmin_pix),tr.ymin_pix-.1*(tr.ymax_pix-tr.ymin_pix)); 

  // Tracer 0C
  if(tr.xmin < 0 && tr.xmax > 0 ){
    ctx.beginPath(); 
    ctx.strokeStyle = 'red';
    xx_pix=Math.round(tr.d2px(0.0))+.5;
    ctx.moveTo(xx_pix,tr.ymin_pix);
    ctx.lineTo(xx_pix,tr.ymax_pix);
    ctx.stroke(); 
  }

  //==================
  // Tracer la surface
  ctx.beginPath(); 
  ctx.strokeStyle = '#E80';
  ctx.fillStyle = '#E80';
  yy_pix=Math.round(tr.d2py(p0[fcstind]))+.5;
  ctx.moveTo(tr.xmin_pix,yy_pix);
  ctx.lineTo(tr.xmax_pix,yy_pix);
  ctx.stroke();
  ctx.textAlign="left"; 
  ctx.textBaseline="top"; 
  ctx.fillText(' Surface',tr.xmin_pix,yy_pix);  
  ctx.restore();  
  
  turb=toutou_turbulence(p0[fcstind],levs,temp,force);

  //==================================================================
  // Determiner si les entrees dans le vecteurs sont au-dessus du sol,
  // dans ce cas mettre tracer[k]=1;
  for (var k=0; k < nk; k++) { 
    if(k==0){	    
      tracer[k]=1;
    } else {
      if(p0[fcstind]-levs[k] > thermo.dpmin){	  
	tracer[k]=1;
        if(k_particule == -1){k_particule=k;}
      }else{
	tracer[k]=0;
      }
    }
  }

  //========================================================
  // Tracer la particule et le LCL Lifted Condensation Level
  //
  //
  // Melange du rs sur le 50 premier hPa avec la technique des aires egales en pression
  //
  //
  //                                    N
  //                                   ---
  //                                   \
  //   N                               /   ri*dpi
  //  ---                              ---
  //  \                                i=1
  //  /  (ri-ravg)*dpi = 0  => ravg = ------------
  //  ---                               N
  //  i=1                              ---
  //                                   \
  //                                   /   dpi
  //                                   ---
  //                                   i=1
  //                            
    depth=50;
    pbot=p0[fcstind];
    sum_p=0;
    ravg=0;
    for (var k=1; k < nk-1; k++) {
	if(tracer[k] == 1){
	    rs=thermo.rapport_de_melange_saturant(ttdd[k]+thermo.tcdk,levs[k]);
	    // Est-ce que l'interface entre le niveau courrant et le suivant est sous p0-depth
	    ptop=.5*(levs[k+1]+levs[k]);
	    if(p0[fcstind]-ptop <= depth){
		// Ajouter la totalite de cette couche
		dp=pbot-ptop;
		sum_p=sum_p+dp;
		ravg=ravg+rs*dp;
		pbot=ptop;
	    }else{
		// Ajouter partiellement la derniere couche en altitude, 
		// de son niveau du bas jusqu'a P0-depth
		ptop=p0[fcstind]-depth;
		dp=pbot-ptop;
		sum_p=sum_p+dp;
		ravg=ravg+rs*dp;
		break;
	    }
	}
    }
    ravg=ravg/sum_p;
    tavg=thermo.temperature_a_rapport_de_melange_saturant(ravg,levs[k_particule])-thermo.tcdk;

  ctx.beginPath();
  ctx.fillStyle = 'red';
  ctx.strokeStyle = 'red';
  //var temp_lcl=thermo.sttlcl(ttdd[k_particule]+thermo.tcdk,temp[k_particule]+thermo.tcdk);
    var temp_lcl=thermo.sttlcl(tavg+thermo.tcdk,temp[k_particule]+thermo.tcdk);
  pres_lcl=levs[k_particule]*100.*Math.pow(temp_lcl/(temp[k_particule]+thermo.tcdk),1/thermo.cappa)/100.;
  temp_lcl=temp_lcl-thermo.tcdk;
  // rs constant
  //xx=tr.d2px(ttdd[k_particule]);
  xx=tr.d2px(tavg);
  yy=tr.d2py(levs[k_particule]);
  ctx.moveTo(xx,yy);
  for (var k=Math.min(k_particule+1,nk-1); k < nk; k++) {
      val=thermo.temperature_a_rapport_de_melange_saturant(ravg,levs[k])-thermo.tcdk;
      if(val <= temp_lcl){
	  break;
      }else{
	  xx=tr.d2px(val);
	  yy=tr.d2py(levs[k]);
	  ctx.lineTo(xx,yy);
          //ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
      }
  }
  xx=tr.d2px(temp_lcl);
  yy=tr.d2py(pres_lcl);
  ctx.lineTo(xx,yy);
  //xx=tr.d2px(ttdd[k_particule]);
  xx=tr.d2px(tavg);
  yy=tr.d2py(levs[k_particule]);
  // theta constant
  xx=tr.d2px(temp[k_particule]);
  yy=tr.d2py(levs[k_particule]);
  ctx.moveTo(xx,yy);
  theta=(temp[k_particule]+thermo.tcdk)*Math.pow(thermo.p0theta/levs[k_particule],thermo.cappa);
  for (var k=Math.min(k_particule+1,nk-1); k < nk; k++) {
      val=theta/Math.pow(thermo.p0theta/levs[k],thermo.cappa)-thermo.tcdk;
      if(val <= temp_lcl){
	  break;
      }else{
	  xx=tr.d2px(val);
	  yy=tr.d2py(levs[k]);
	  ctx.lineTo(xx,yy);
          //ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
      }
  }    
  xx=tr.d2px(temp_lcl);
  yy=tr.d2py(pres_lcl);
  ctx.lineTo(xx,yy);
  ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
  ctx.textAlign="right";
  ctx.textBaseline="middle";
  ctx.fillText('LCL ',xx,yy);
  pointsData['profils'].push({type:'lcl', x:xx, y:yy, tt:temp_lcl, pres:pres_lcl});
  ctx.stroke();
  // pseudo adi. a partir du LCL
  var res=thermo.pseudo_adiabatique_saturee(temp_lcl+thermo.tcdk,pres_lcl,650.,-10.);
  ctx.beginPath();
  xx=tr.d2px(res.tt[0]-thermo.tcdk);
  yy=tr.d2py(res.pp[0]);	
  ctx.moveTo(xx,yy);
  for (var k=1; k < res.n; k++) {
    xx=tr.d2px(res.tt[k]-thermo.tcdk);
    yy=tr.d2py(res.pp[k]);	
    ctx.lineTo(xx,yy);
  }
  ctx.stroke();

  //============================================
  // Tracer le CCL Convective Condensation Level
  //
  // 
  ctx.beginPath();
  ctx.fillStyle = 'aqua';
  ctx.strokeStyle = 'aqua';
    xx=tr.d2px(temp_lcl);
    yy=tr.d2py(pres_lcl);
    ctx.moveTo(xx,yy);
    var valm=0.;
    var valmm=0.;
    for (var k=1; k < nk; k++) {
	if(tracer[k] == 1){
	    val=thermo.temperature_a_rapport_de_melange_saturant(ravg,levs[k])-thermo.tcdk;
	    if(val >= temp[k]){
		// CCL is between level k and k-1, temperature val valm respectively
		if(k >= 3){
		    dtk=temp[k]-temp[k-1];
		    dtrm=valm-valmm;
		    tccl=dtrm/dtk*(-temp[k-1]*levs[k]+temp[k]*levs[k-1]);
		    tccl=tccl+valmm*levs[k-1]-valm*levs[k-2];
		    tccl=tccl/(dtrm/dtk*(-levs[k]+levs[k-1])+levs[k-1]-levs[k-2]);
		    aaa=1./(temp[k]-temp[k-1]);
		    pccl=(tccl-temp[k-1])*aaa*levs[k]+(temp[k]-tccl)*aaa*levs[k-1];
		    xx=tr.d2px(tccl);
		    yy=tr.d2py(pccl);	
		    ctx.lineTo(xx,yy);
		    ctx.textAlign="left";
		    ctx.textBaseline="bottom";
		    ctx.fillText('CCL',xx,yy);
                    pointsData['profils'].push({type:'ccl', x:xx, y:yy, tt:tccl, pres:pccl});
		    // Tracer theta constant vers le bas
		    theta=(tccl+thermo.tcdk)*Math.pow(thermo.p0theta/pccl,thermo.cappa);
		    for (var i=k-1; i >= 1; i--) {
			if(tracer[i] == 1){
			    ttt=theta/Math.pow(thermo.p0theta/levs[i],thermo.cappa)-thermo.tcdk;
			    if(ttt < tr.xmax){
				xx=tr.d2px(ttt);
				yy=tr.d2py(levs[i]); 
				ctx.lineTo(xx,yy);
				ctx.stroke();
			    }
			}
		    }
		    ttt=theta/Math.pow(thermo.p0theta/p0[fcstind],thermo.cappa)-thermo.tcdk;
		    if(ttt < tr.xmax){
			xx=tr.d2px(ttt);
			yy=tr.d2py(p0[fcstind]); 
			ctx.lineTo(xx,yy);
			ctx.textAlign="left";
			ctx.textBaseline="bottom";
		      ctx.fillText('TC',xx,yy);
		      pointsData['profils'].push({type:'tc', x:xx, y:yy, tc:ttt});
		    }
                    // Tracer theta w a partir du CCL jusqu'au ce que ttt < temp environnement
		    xx=tr.d2px(tccl);
		    yy=tr.d2py(pccl);
		    ctx.moveTo(xx,yy);
		    tm=tccl;
		    pm=pccl;
		    for (var i=k; i < nk; i++) {
			// Il y aura 2 points dans rs
			res=thermo.pseudo_adiabatique_saturee(tm+thermo.tcdk,pm,levs[i],levs[i]-pm);
			tm=res.tt[1]-thermo.tcdk;
			pm=res.pp[1];
			if(tm<temp[i]){
			    ctx.stroke();				
			    break;
			}
			xx=tr.d2px(res.tt[1]-thermo.tcdk);
			yy=tr.d2py(res.pp[1]);
			ctx.lineTo(xx,yy);
			if(i==nk-1){ctx.stroke();}
		    }
		    break;
		} else {

		}
	    }else{
		if(levs[k] <= pres_lcl){
		    xx=tr.d2px(val);
		    yy=tr.d2py(levs[k]);	
		    ctx.lineTo(xx,yy);		
		}
	    }
	    valmm=valm;
	    valm=val;
	}
    }
    ctx.stroke();

  //==============================================
  // Tracer T  
  ctx.beginPath();
  ctx.fillStyle = 'blue';
  ctx.strokeStyle = 'blue';
  xx=tr.d2px(temp[0]);
  yy=tr.d2py(p0[fcstind]);
  ctx.moveTo(xx,yy);
  ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
  pointsData['profils'].push({type:'profil', x:xx, y:yy, hh:hhh[fcstind], pres:p0[fcstind], heights:0., tt:temp[0], td:ttdd[0], wd:force[0], dir:dir[0]});
  for (var k=1; k < nk; k++) {
    if(tracer[k] == 1){
      xx=tr.d2px(temp[k]);
      yy=tr.d2py(levs[k]);
      ctx.lineTo(xx,yy);
      ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
    }
  }
  ctx.stroke();

  //==============================================
  // Tracer melange
  ctx.beginPath(); 
  ctx.textAlign="left";                                                                                                        
  ctx.textBaseline="bottom";
  ctx.fillStyle = 'red'; 
  ctx.strokeStyle = 'red'; 
  for (var k=1; k < nk; k++) {
    if(turb.stable[k] <= 0){
      yy=tr.d2py(.5*(levs[k]+levs[k-1]));
      xx=tr.d2px(.5*(temp[k]+temp[k-1])); 
      if(turb.stable[k] == 0){
	ctx.fillText('mélange',xx,yy);
      }	else {
	ctx.fillText('mélange residuel',xx,yy);
      }
    }
  }
  ctx.stroke(); 

  //==============================================
  // Tracer Td
  ctx.beginPath();
  ctx.fillStyle = pointsData['profils_params'].td_col;
  ctx.strokeStyle = pointsData['profils_params'].td_col;
  xx=tr.d2px(ttdd[0]);
  yy=tr.d2py(p0[fcstind]);  
  ctx.moveTo(xx,yy);
  ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
  pointsData['profils'].push({type:'profil', x:xx, y:yy, hh:hhh[fcstind], pres:p0[fcstind], heights:0., tt:temp[0], td:ttdd[0], wd:force[0], dir:dir[0]});
  for (var k=1; k < nk; k++) {
    if(tracer[k] == 1){
      xx=tr.d2px(ttdd[k]);
      yy=tr.d2py(levs[k]);
      ctx.lineTo(xx,yy);
      ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
    }
  }
  ctx.stroke();  

  //==============================================
  // Calculer et ecrire les hauteurs GZ
  var hu=thermo.sesahu(temp[0]-ttdd[0],temp[0]+thermo.tcdk,p0[fcstind]*100.,0,0,1,1);
  var tvm=(temp[0]+thermo.tcdk)*(1.+thermo.delta*hu);  
  var tvp=0.;
  var gz=0.;
  var lnpm=Math.log(p0[fcstind]*100.);
  var lnpp=0.;
  ctx.font = my_fonts.axis;
  ctx.beginPath(); 
  ctx.fillStyle = "Black";
  ctx.strokeStyle = 'black';      
  ctx.textAlign="left";
  ctx.textBaseline="middle";  
  for (var k=1; k < nk; k++) {  
    if(tracer[k] == 1){
      // Calcul de GZ
      hu=thermo.sesahu(temp[k]-ttdd[k],temp[k]+thermo.tcdk,levs[k]*100.,0,0,1,1);
      tvp=(temp[k]+thermo.tcdk)*(1.+thermo.delta*hu);
      // Tracer Tv pour debug de la fonction thermo.sesahu
      //xx=tr.d2px(tvp-thermo.tcdk);
      //ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
      lnpp=Math.log(levs[k]*100.);
      gz=gz+thermo.rgasd*.5*(tvm+tvp)*(lnpm-lnpp)/thermo.grav;
      lnpm=lnpp;      
      yy=Math.round(tr.d2py(Math.exp(.5*(lnpm+lnpp))/100.));
      ctx.fillText(' '+Math.round(gz)+' [m]',tr.xmin_pix,yy);
      xx=tr.d2px(ttdd[k]);
      yy=tr.d2py(levs[k]);
      pointsData['profils'].push({type:'profil', x:xx, y:yy, hh:hhh[fcstind], pres:levs[k], heights:gz, tt:temp[k], td:ttdd[k], wd:force[k], dir:dir[k]});
      xx=tr.d2px(temp[k]);
      pointsData['profils'].push({type:'profil', x:xx, y:yy, hh:hhh[fcstind], pres:levs[k], heights:gz, tt:temp[k], td:ttdd[k], wd:force[k], dir:dir[k]});
    }
  }

  //==============================================
  // Tracer des rectangles blancs de chaque cote pour effacer les courbes theta et Td qui depassent.
  ctx.stroke();
  ctx.fillStyle = 'white'; 
  // Note tr.dd, de largeur du symbole des courbes est negatif.
  ctx.fillRect(0            , tr.pix_margeh+tr.dd, tr.pix_margeg       , tr.pix_margeb-tr.pix_margeh-2*tr.dd);
  ctx.fillRect(tr.pix_marged, tr.pix_margeh+tr.dd, gxsize-tr.pix_marged, tr.pix_margeb-tr.pix_margeh-2*tr.dd);
  
  // yticks
  ctx.beginPath();
  ctx.font = my_fonts.axis;
  ctx.fillStyle = "Black";
  ctx.strokeStyle = 'black';      
  ctx.textAlign="right";
  ctx.textBaseline="middle";
  xx=Math.round(tr.xmin_pix-.01*(tr.xmax_pix-tr.xmin_pix))+.5;
  for (var i=0; i < levels3.length; i++) {	
    yy=Math.round(tr.d2py(levels3[i]))+.5;
    ctx.moveTo(tr.xmin_pix,yy);
    ctx.lineTo(xx,yy);
    ctx.fillText(levels3[i]+' ',xx,yy);
  }
  ctx.stroke();

  // Legende y
  ctx.save();
  ctx.translate(0,.5*(tr.ymax_pix+tr.ymin_pix)); 
  ctx.rotate(-.5*Math.PI);
  ctx.textAlign="center";
  ctx.textBaseline="top";
  ctx.font = my_fonts.axis;
  ctx.fillStyle = "black";
  ctx.fillText("Pression [hPa]",0,0);
  ctx.restore();
  
  //==============================================
  // Tracer les vents
  // Tracer les fleches de direction
  xx_pix=tr.xmax_pix+.03*(tr.xmax_pix-tr.xmin_pix);
  pix_dl=(tr.xmax_pix-tr.xmin_pix)*.02; // Longueur des fleches en pixel 
  
  for (var k=0; k < nk; k++) { 
    if(dir[k]<990){
      if(tracer[k] == 1){
	ctx.fillStyle = 'red'; 
	ctx.strokeStyle = 'red'; 
	my_rad=deg2rad*dir[k];
	// Corps de la fleche
	pix_fx = Math.round( Math.sin(my_rad) * pix_dl ); 
	pix_fy = Math.round( Math.cos(my_rad) * pix_dl );
	ctx.beginPath();
	if( k == 0){
	  yy_pix=tr.d2py(p0[fcstind]);
	}else{
	  yy_pix=tr.d2py(levs[k]);
	}
	ctx.moveTo(xx_pix+pix_fx,yy_pix-pix_fy);
	ctx.lineTo(xx_pix-pix_fx,yy_pix+pix_fy);
	ctx.stroke(); 
	
	// Pointe de la fleche
	//ctx.beginPath();
	ctx.moveTo(xx_pix-pix_fx,yy_pix+pix_fy); 
	// Pointe de la fleche cote gauche 
	px_pix = Math.round( Math.sin(my_rad+1.3) *.4* pix_dl ); 
	py_pix = Math.round( Math.cos(my_rad+1.3) *.4* pix_dl ); 
	ctx.lineTo(xx_pix-px_pix,yy_pix+py_pix);
	
	// Pointe de la fleche cote droit 
	px_pix = Math.round( Math.sin(my_rad-1.3) *.4* pix_dl ); 
	py_pix = Math.round( Math.cos(my_rad-1.3) *.4* pix_dl ); 
	ctx.lineTo(xx_pix-px_pix,yy_pix+py_pix);
	ctx.closePath();
	ctx.fill();
	ctx.textAlign="left";
	ctx.textBaseline="middle";
	ctx.fillStyle = 'black'; 
	ctx.strokeStyle = 'black'; 
	ctx.fillText(" "+Math.round(force[k])+' '+unitJson.unite,xx_pix+pix_dl,yy_pix);
      }
      
    }
  }
}
